<script setup lang="ts">
import { computed, ref } from 'vue';

// radius/blur 不传 → 走密度套餐 CSS 变量 (--glass-radius/--glass-blur, 站长可调全站气质);
// 显式传数值 → 该卡片自定义 (覆盖密度)。
const props = withDefaults(
  defineProps<{
    radius?: number;
    blur?: number;
    tint?: string;
    border?: string;
    hover?: boolean;
    clickable?: boolean;
  }>(),
  {
    radius: undefined,
    blur: undefined,
    tint: 'var(--aurora-glass-tint)',
    border: 'var(--aurora-glass-border)',
    hover: false,
    clickable: false,
  },
);
const radiusCss = computed(() => (props.radius != null ? `${props.radius}px` : 'var(--glass-radius, 20px)'));
const blurCss = computed(() => (props.blur != null ? `${props.blur}px` : 'var(--glass-blur, 24px)'));

const hovered = ref(false);
function onEnter() {
  if (props.hover) hovered.value = true;
}
function onLeave() {
  if (props.hover) hovered.value = false;
}
</script>

<template>
  <div
    class="glass"
    :class="{ 'glass--hovered': hovered, 'glass--clickable': clickable || hover }"
    :style="{
      borderRadius: radiusCss,
      background: tint,
      backdropFilter: `blur(${blurCss}) saturate(180%)`,
      WebkitBackdropFilter: `blur(${blurCss}) saturate(180%)`,
      border: `1px solid ${border}`,
    }"
    @mouseenter="onEnter"
    @mouseleave="onLeave"
  >
    <div aria-hidden class="glass__highlight" />
    <div class="glass__inner">
      <slot />
    </div>
  </div>
</template>

<style scoped>
.glass {
  position: relative;
  overflow: hidden;
  transition:
    box-shadow 0.35s cubic-bezier(0.2, 0.7, 0.3, 1),
    transform 0.35s cubic-bezier(0.2, 0.7, 0.3, 1);
  box-shadow:
    0 1px 0 0 rgba(255, 255, 255, 0.3) inset,
    0 -1px 0 0 rgba(0, 0, 0, 0.1) inset,
    0 10px 30px rgba(0, 0, 0, 0.2),
    0 2px 6px rgba(0, 0, 0, 0.12);
  cursor: default;
}
.glass--clickable {
  cursor: pointer;
}
.glass--hovered {
  transform: translateY(-2px);
  box-shadow:
    0 1px 0 0 rgba(255, 255, 255, 0.35) inset,
    0 20px 60px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(255, 126, 95, 0.25);
}
.glass__highlight {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.1), transparent);
  pointer-events: none;
}
.glass__inner {
  position: relative;
  z-index: 1;
  height: 100%;
}
</style>
